import { render, staticRenderFns } from "./c_comb_data.vue?vue&type=template&id=0336a6c0&scoped=true"
import script from "./c_comb_data.vue?vue&type=script&lang=js"
export * from "./c_comb_data.vue?vue&type=script&lang=js"
import style0 from "./c_comb_data.vue?vue&type=style&index=0&id=0336a6c0&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0336a6c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\www\\mer\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0336a6c0')) {
      api.createRecord('0336a6c0', component.options)
    } else {
      api.reload('0336a6c0', component.options)
    }
    module.hot.accept("./c_comb_data.vue?vue&type=template&id=0336a6c0&scoped=true", function () {
      api.rerender('0336a6c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pagediy/components/mobileConfigRight/c_comb_data.vue"
export default component.exports